import { SxProps, Theme } from '@mui/material';
import colors from '../../common/colors';

type StylesConfig = {
  container: SxProps<Theme>;
  content: SxProps<Theme>;
  iconWrapper: SxProps<Theme>;
  message: SxProps<Theme>;
};

const styles: StylesConfig = {
  container: {
    display: 'flex',
    position: 'fixed',
    inset: 0,
    backgroundColor: colors.background,
    justifyContent: 'center',
    alignItems: 'center',
    boxSizing: 'border-box',
    overflow: 'hidden',
    padding: { xs: '16px', sm: '32px', md: '40px' },
    zIndex: (theme) => theme.zIndex.modal,
  },
  content: {
    backgroundColor: colors.white,
    border: `1px solid ${colors.neutral_300}`,
    borderRadius: '8px',
    padding: { xs: '24px 20px', sm: '32px 24px', md: '40px' },
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: { xs: '12px', md: '16px' },
    width: '100%',
    maxWidth: { xs: '100%', sm: '420px', md: '520px' },
    textAlign: 'center',
    boxSizing: 'border-box',
  },
  iconWrapper: {
    color: colors.red_100,
    '& svg': { fontSize: { xs: '32px', md: '40px' } },
  },
  message: {
    fontSize: { xs: '15px', md: '18px' },
    fontWeight: 600,
    color: colors.grey_300,
    lineHeight: 1.4,
    wordBreak: 'break-word',
  },
};

export default styles;
